<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @new-item="openModalAdd"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:before-actions"  slot-scope="data">
                                <div class="table-actions-dropdown" v-if="data.item.supplier_id">
                                    <b-dropdown class="btn" left v-b-tooltip.hover title="Actions">
                                        <b-dropdown-item href="javascript:void(0)" @click="showAddLD(data.item)">Add LD</b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </template>
                            <template slot="gofix_table:order_issue_date" slot-scope="data">
                                {{data.item.order_issue_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:completed_date" slot-scope="data">
                                {{data.item.completed_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                          <template slot="gofix_table:total_net_amount" slot-scope="data">
                            {{data.item.total_net_amount  | formatMoney}}
                          </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-button @click="openModalAdd" v-if="isAllowCreateWO" class="enabledBtn"><img src="img/enabledBtn.png" alt="" /></b-button>
            <b-modal :no-close-on-backdrop="true" id="modal-create-orders" title="Create Work Order" hide-footer :centered="true" v-model="modals.create.open" ref="modal-create-orders">
                <b-form class="formV2" v-bind:class="{'run-loading':loading.createOrder}">
                    <gofix-form-dropdown
                            label="Work Type"
                            required
                            :options="workType"
                            v-model="OrderCreateObj.order_type"
                            :filterable="false"
                            vLabel="text"
                            :reduce="option => option.value">
                    </gofix-form-dropdown>
                    <gofix-form-dropdown
                            label="Client Contract"
                            required
                            :options="clientContracts"
                            @search="searchContract"
                            v-model="OrderCreateObj.contract_id"
                            :filterable="false"
                            vLabel="contract_name"
                            :reduce="contract => contract.id">
                    </gofix-form-dropdown>
                    <gofix-form-tree
                            label="Service Category"
                            :default-expand-level="1"
                            ref="seviceCategoriesField"
                            :multiple="false"
                            :options="serviceCategories"
                            :load-options="loadOptionServices"
                            search-nested
                            v-model="OrderCreateObj.service_category_id"
                            :normalizer="normalizer"
                            placeholder="">
                    </gofix-form-tree>
                    <gofix-form-properties
                            label="Service Location"
                            :contract-id="OrderCreateObj ? OrderCreateObj.contract_id : null"
                            showIconRequired
                            v-model="OrderCreateObj.service_location">
                    </gofix-form-properties>

                    <gofix-form-dropdown
                            label="Priority"
                            vLabel="priority"
                            :filterable="false"
                            v-model="OrderCreateObj.sla_id"
                            :reduce="option => option.id"
                            :options="listSLA">
                    </gofix-form-dropdown>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="createOrder" :disabled="!this.$checkRole(this.$accessModule.order, 'create')" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-create-orders" title="Add Liquidated Damages" hide-footer :centered="true" v-model="modals.addLD.open">
                <b-form class="formV2" v-bind:class="{'run-loading':modals.addLD.loading}">
                    <b-row>
                        <b-col sm="6">
                            <gofix-form-input-number
                                    desc="$(0.00)"
                                    allowNegative
                                    label="Total Amount"
                                    v-model="modals.addLD.data.total"
                                    @change="changeAmount"
                                    required
                                    prefix="$("
                                    suffix=")"></gofix-form-input-number>
                        </b-col>
                        <b-col sm="6">
                            <gofix-form-dropdown
                                    label="GL Code"
                                    :reduce="option => option.id"
                                    :options="modals.addLD.glCodes"
                                    v-model="modals.addLD.data.gl_code_id"
                                    :getOptionLabel="getOptionLabel"
                                    :filterable="true">
                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                    <div class="flex">
                                        <div class="">
                                            <span>{{option.gl_code + " " + option.name }}</span>
                                        </div>
                                    </div>
                                </template>
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    {{ option.gl_code + " " + option.name }}
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col sm="12">
                            <gofix-form-dropdown
                                label="FM Code"
                                vLabel="fm_code"
                                :reduce="option => option.id"
                                :options="modals.addLD.fmCodes"
                                @search="searchFMCode"
                                append-to-body
                                v-model="modals.addLD.data.fm_code_id"
                                :filterable="false">
                            <!-- <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <div class="flex">
                                    <div class="">
                                        <span>{{ option.chart_of_account ? option.fm_code + " - " + option.gl_code + " - " + option.chart_of_account.name : option.fm_code + " - " + option.gl_code}}</span>
                                    </div>
                                </div>
                            </template>
                            <template #gofixInput:dropdown:option="option">
                                {{ option.chart_of_account ? option.fm_code + " - " + option.gl_code + " - " + option.chart_of_account.name : option.fm_code + " - " + option.gl_code }}
                            </template> -->
                        </gofix-form-dropdown>
                        </b-col>
                        <b-col sm="12">
                            <gofix-form-input-textarea label="Reason" required :rows="4" v-model="modals.addLD.data.reasons">
                            </gofix-form-input-textarea>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="createLD" :loading="modals.addLD.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
              <b-progress-bar :value="100">
                <span class="font-size-16">{{modals.export.process}}</span>
              </b-progress-bar>
            </b-progress>
          </b-modal>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'Orders',
        props:["orderType"],
        data() {
            let filter = JSON.parse(JSON.stringify(filters['order']));
            if(this.orderType){
                filter.work_type.value = this.orderType;
            }
            return {
                tableConfig:{
                    dataSelect: {
                        order_status: {
                            value: [
                                {value: 'Issued', text: 'Issued'},
                                {value: 'COD Raised', text: 'COD Raised'},
                                {value: 'Under Approval', text: 'Under Approval'},
                                {value: 'Pending Revision', text: 'Pending Revision'},
                                {value: 'Approved', text: 'Approved'},
                                {value: 'Dispatched', text: 'Dispatched'},
                                {value: 'Acknowledged', text: 'Acknowledged'},
                                {value: 'Rejected', text: 'Rejected'},
                                {value: 'On-Site', text: 'On-Site'},
                                {value: 'Partially Completed', text: 'Partially Completed'},
                                {value: 'Completed', text: 'Completed'},
                                {value: 'Invoiced', text: 'Invoiced'},
                                {value: 'Closed', text: 'Closed'},
                                {value: 'Cancelled', text: 'Cancelled'}
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                    name: 'work-order-all-order',
                    controls:{
                        create: this.$checkRole(this.$accessModule.order, 'create'),//this.orderType !== 'Preventive'
                        delete: this.$checkRole(this.$accessModule.order, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
                modals:{
                    create:{
                        open: false
                    },
                    addLD:{
                        open: false,
                        loading: false,
                        data: {
                            total:null,
                            reasons:null,
                            gl_code_id:null,
                            fm_code_id:null,
                            client_contract_id: null,
                            client_contract: null,
                            supplier_id: null,
                            ld_date:  moment().format("YYYY-MM-DD"),
                            status: "Draft",
                            order_id: null,
                        },
                        glCodes:[],
                        fmCodes:[],
                        timer: {
                            fm_code: null
                        }
                    },
                  export:{
                    open:false,
                    loading:false,
                    process:'Creating file csv',
                    title: 'Export Data'
                  }
                },
                workType: [
                    {
                        value: "Preventive",
                        disabled: true,
                        text : "Preventive Work Order (PWO)",
                    },
                    {
                        value: "Corrective",
                        disabled: false,
                        text : "Corrective Work Order (CWO)",
                    },
                    {
                        value: "Reactive",
                        disabled: false,
                        text : "Reactive Work Order (RWO)",
                    },
                ],
                clientContracts : [],
                normalizer(node) {
                    if (node.isBatch)
                        return {
                            label: node.name,
                            children: node.children
                        };
                    return {
                        label: node.name,
                        children: undefined
                    }
                },
                loading:{
                    serviceCategory:false,
                    properties:false,
                    createOrder:false,
                },
                serviceCategories:[],
                listSLA: [],
            }
        },
        created() {
            //Get client contract
            if(this.ListClientContract.total === 0) {
                this.$store.dispatch('ContractController/getListClientContractsSearch', [1, null, 100])
                    .then(response => {  this.clientContracts = response.data }).catch(error => {})
            }
            else {
                this.clientContracts = this.ListClientContract.data
            }
            this.getCOA();
        },
        computed: {
            ...mapGetters({
                OrderCreateObj: 'OrderController/OrderCreateObj',
                ListClientContract: 'ContractController/ListClientContract',
                ClientContractID: 'ContractController/ClientContractID',
                currentRoles: 'AuthController/roles',
                UserLogin: "AuthController/user",
            }),
            isAllowCreateWO() {
                if(this.$checkRole(this.$accessModule.order, 'create')) {
                    if(this.UserLogin && this.UserLogin.organization && this.UserLogin.organization.is_supplier) {
                        if(this.$checkRole(this.$accessModule.allow_supplier_to_create_wo, 'allow_supplier_to_create_wo')) return true
                        return false
                    }
                    return true
                }
                return false
            }
        },
        watch: {
            "OrderCreateObj.contract_id": function(val){
                this.OrderCreateObj.service_category_id = null;
                this.OrderCreateObj.service_location = null;
                if(val) {
                    this.loadRootServiceCategory();
                }
                else {
                    this.serviceCategories = [];
                }
            },
            "OrderCreateObj.service_category_id": function(val){
                this.OrderCreateObj.sla_id = null;
                this.listSLA = [];
                if(val) {
                    this.loadSLAByServiceCate()
                }
            },
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.isAllowCreateWO,
                    delete: this.$checkRole(this.$accessModule.order, 'delete')
                }
            },
            UserLogin() {
                this.tableConfig.controls = {
                    create: this.isAllowCreateWO,
                    delete: this.$checkRole(this.$accessModule.order, 'delete')
                }
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("OrderController/getItems", tableRequest)
                    .then(response => {                        
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load orders", "danger");
                        reject();
                    });
            },
            async clickToRowItem(item){
                this.$router.push(`/v2/orders/${item.id}`);
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('OrderController/deleteItems', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'order'))
                    })
                    .catch(err => {
                        reject();
                    });
            },
            async exportItems(){
              let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
              request.limit = -1;
              let that = this;
              this.modals.export.open = true;
              this.modals.export.process = "Creating file xlsx";
              await global.axios('api/orders/export', {
                method: "GET",
                params: request,
                responseType: 'blob',
                onDownloadProgress (progress) {
                  that.modals.export.process = "Downloading";
                }
              })
                  .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'orders.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.modals.export.open = false
                  })
                  .catch(error => {
                    this.modals.export.open = false
                  });
            },
            openModalAdd() {
                this.modals.create.open = true;
                if(this.ClientContractID && this.ClientContractID.hasOwnProperty('id') && this.ClientContractID.id == this.OrderCreateObj.contract_id) {
                    this.loadRootServiceCategory();
                }
                this.$store.commit("OrderController/setOrderCreateObj",{
                    "order_type" : this.orderType ?  this.orderType : null,
                    "contract_id" : (this.ClientContractID && this.ClientContractID.hasOwnProperty('id')) ? this.ClientContractID.id : null,
                    "service_category_id" : null,
                    "service_location" : null,
                    "sla_id" : null,
                    "order_status" : "Issued",
                })
            },
            searchContract(search, loading){
                this.clientContracts = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('ContractController/getListClientContractsSearch', [1, {contract_name: search }, 1000])
                        .then(response => {
                            this.clientContracts = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            loadRootServiceCategory(){
                this.loading.serviceCategory = true;
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                    contractId: this.OrderCreateObj.contract_id,
                    categoryId: 0
                }).then(response => {
                    this.serviceCategories = [];
                    this.serviceCategories = response;
                    this.loading.serviceCategory = false;
                });
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.OrderCreateObj.contract_id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }
            },
            loadSLAByServiceCate(){
                this.loading.sla = true;
                this.$store.dispatch("v2SlaController/getSlaList", {
                    limit:-1,
                    page:1,
                    filter: {
                        service_category_id:this.OrderCreateObj.service_category_id
                    },
                }).then(response => {
                    this.loading.sla = false;
                    this.listSLA = response.items;
                });
            },
            createOrder(){
                let bug = false;
                if(!this.OrderCreateObj.order_type){
                    this.$alertNotification("Please select a order type", "danger");
                    bug = true;
                }
                if(!this.OrderCreateObj.contract_id){
                    this.$alertNotification("Please select a client contract", "danger");
                    bug = true;
                }
                if(!this.OrderCreateObj.service_category_id){
                    this.$alertNotification("Please select a service category", "danger");
                    bug = true;
                }
                if(!this.OrderCreateObj.service_location){
                    this.$alertNotification("Please select a service location", "danger");
                    bug = true;
                }
                if(!this.OrderCreateObj.sla_id){
                    this.$alertNotification("Please select a priority", "danger");
                    bug = true;
                }
                if(bug) return;
                this.loading.createOrder = true;
                this.$store.dispatch("OrderController/createOrder",this.OrderCreateObj)
                    .then(async data => {
                        this.loading.createOrder = false;
                        await this.$router.push(`/v2/orders/${data.id}`);
                        await this.$alertNotification(this.$notificationV2('adding', 'order'));
                    })
                    .catch(err => {
                        this.loading.createOrder = false;
                        this.$alertNotification("Can't create new order!");
                    })
            },
            changeAmount(){
                if(this.modals.addLD.data.total){
                    let amount = this.$accounting.unformat(this.modals.addLD.data.total);
                    if(amount > 0){
                        this.modals.addLD.data.total = this.$accounting.formatMoney((0 - amount), { format: {
                            pos : "%s %v",
                            neg : "%s (%v)",
                            zero: "%s %v"
                        } });
                    }
                }
            },
            getCOA() {
                this.$store.dispatch("FmCodeController/getCOA",{limit: -1})
                    .then(response => {
                        this.modals.addLD.glCodes = response.items;
                    }).catch(err => {
                        this.modals.addLD.glCodes = [];
                    });
            },
            getFMCode(filter = null, limit = 100) {
                let contractID = this.modals.addLD.data.client_contract_id
                this.$store.dispatch("FmCodeController/getFmCodeItems", { limit: limit, page: 1, filter: filter, contract_id : contractID })
                .then(response => {
                    this.modals.addLD.fmCodes = response.items;
                })
            },
            searchFMCode(search, loading) {
                this.modals.addLD.fmCodes = []
                loading(true);
                if (this.modals.addLD.timer.fm_code) {
                    clearTimeout(this.modals.addLD.timer.fm_code);
                    this.modals.addLD.timer.fm_code = null;
                }
                this.modals.addLD.timer.fm_code = setTimeout(async () => {
                    try {
                        await this.getFMCode({fm_code: search});
                        await loading(false);
                    }
                    catch(err) {
                        loading(false);
                    }
                }, 500);
            },
            showAddLD(item){
                this.modals.addLD.data.order_id = item.id;
                this.modals.addLD.data.client_contract_id = item.contract_id;
                this.modals.addLD.data.client_contract = item.client_contract ? item.client_contract : null;
                this.modals.addLD.data.supplier_id = item.supplier_id;
                this.modals.addLD.open = true
                this.getFMCode()
            },
            createLD(){
                if(this.modals.addLD.loading) return;
                if(this.modals.addLD.data.total === null){
                    return this.$alertNotification("The total is a required field.", "danger");
                }
                if(!this.modals.addLD.data.reasons){
                    return this.$alertNotification("The reason is a required field.", "danger");
                }
                if(this.modals.addLD.data.client_contract && this.modals.addLD.data.client_contract.settings && this.modals.addLD.data.client_contract.settings.is_required_gl_code && !this.modals.addLD.data.gl_code_id) {
                    return this.$alertNotification("GL Code is a required field.", "danger");
                }
                if(this.modals.addLD.data.client_contract && this.modals.addLD.data.client_contract.settings && this.modals.addLD.data.client_contract.settings.is_required_fm_code && !this.modals.addLD.data.fm_code_id) {
                    return this.$alertNotification("FM Code is a required field.", "danger");
                }

                this.modals.addLD.loading = true;
                let data = JSON.parse(JSON.stringify(this.modals.addLD.data));
                data.total = this.$accounting.unformat(data.total);
                this.$store.dispatch(`LiquidatedDamagesController/createItem`,data)
                    .then((response) => {
                        this.$alertNotification(this.$notificationV2('adding', 'liquidated_damages'));
                        this.modals.addLD.open = false;
                        this.modals.addLD.loading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.modals.addLD.loading = false;
                        this.$alertNotification("Can't add the Liquidated Damage", "danger");
                    });
            },
            getOptionLabel(option){
                let label = option.gl_code + " " + option.name;
                return label;
            },
        }
    }
</script>
